import React, { useCallback } from 'react'
import { useModal, Link, Display, Box, Space, AlignItems } from '@gousto-internal/citrus-react'

import type { ShippingAddress } from '@library/api-user'

const DeleteAddressButton = ({ address }: { address: ShippingAddress }) => {
  const { openModal } = useModal()

  const deleteThisAddress = useCallback(
    async (event: React.SyntheticEvent) => {
      event.preventDefault()

      openModal('DeleteAddressModal')
    },
    [openModal],
  )

  return (
    <Box display={Display.Flex} alignItems={AlignItems.Center}>
      <Space direction="horizontal" size={1} />
      <Link size={1} disabled={address.shippingDefault} onClick={deleteThisAddress}>
        Delete
      </Link>
    </Box>
  )
}

export { DeleteAddressButton }
